import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Item\ItemStockExportController::__invoke
* @see app/Http/Controllers/Item/ItemStockExportController.php
* @route '/api/item/export-stocks'
*/
const ItemStockExportController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: ItemStockExportController.url(options),
    method: 'post',
})

ItemStockExportController.definition = {
    methods: ["post"],
    url: '/api/item/export-stocks',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Item\ItemStockExportController::__invoke
* @see app/Http/Controllers/Item/ItemStockExportController.php
* @route '/api/item/export-stocks'
*/
ItemStockExportController.url = (options?: RouteQueryOptions) => {
    return ItemStockExportController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Item\ItemStockExportController::__invoke
* @see app/Http/Controllers/Item/ItemStockExportController.php
* @route '/api/item/export-stocks'
*/
ItemStockExportController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: ItemStockExportController.url(options),
    method: 'post',
})

export default ItemStockExportController